export default [
    { id: 'start' },
    { id: 'sex-birthday-height' },
    { id: 'weight' },
    { id: 'goal' },
    { id: 'diet-id' },
    { id: 'activity-level' },
    { id: 'finish' },
];
